export default function OrderConfirmationPage({ onNavigate, order }) {
  const orderNumber = order?.reference || `MB-${Math.floor(100000 + Math.random() * 900000)}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(orderNumber).then(() => {
      const btn = document.getElementById('copy-order-btn');
      if (btn) {
        btn.textContent = '✓';
        setTimeout(() => { btn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-4 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/></svg>`; }, 2000);
      }
    }).catch(() => {});
  };

  return (
    <div className="min-h-screen bg-[#FAF3F0] flex flex-col items-center justify-center p-4">
      <div className="bg-white rounded-3xl p-8 max-w-md w-full text-center shadow-sm border border-gray-100">
        <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-4xl">🎉</span>
        </div>
        <h1 className="text-2xl font-black text-[#1A1A2E] mb-2">Order Confirmed!</h1>
        <p className="text-gray-500 mb-6 text-sm">
          Thank you for shopping at Manna Bridal. Your order has been successfully placed.
        </p>

        <div className="bg-[#FAF3F0] rounded-2xl p-5 mb-8 text-left">
          <p className="text-xs text-gray-400 font-bold uppercase tracking-wider mb-2">Order Number</p>
          {/* Single line with copy icon */}
          <div className="flex items-center gap-2">
            <p className="text-lg font-black text-[#F47B20] truncate flex-1">{orderNumber}</p>
            <button
              id="copy-order-btn"
              onClick={handleCopy}
              title="Copy order number"
              className="shrink-0 w-8 h-8 flex items-center justify-center rounded-lg bg-white border border-gray-200 hover:border-[#F47B20] hover:text-[#F47B20] text-gray-400 transition-colors shadow-sm"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-4 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            </button>
          </div>

          <div className="mt-4 pt-4 border-t border-gray-200">
            <p className="text-xs text-gray-400 font-bold uppercase tracking-wider mb-1">Order Total</p>
            <p className="text-sm font-bold text-[#1A1A2E]">
              {order?.total ? `₦${Number(order.total).toLocaleString()}` : '—'}
            </p>
          </div>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => onNavigate('orders')}
            className="w-full bg-[#F47B20] hover:bg-[#D96A10] text-white font-bold py-3.5 rounded-2xl text-sm transition-colors shadow-sm"
          >
            Track My Order
          </button>
          <button
            onClick={() => onNavigate('shop')}
            className="w-full bg-[#1A1A2E] hover:bg-black text-white font-bold py-3.5 rounded-2xl text-sm transition-colors shadow-sm"
          >
            Continue Shopping
          </button>
        </div>
      </div>
    </div>
  );
}
